var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"emoji-Bigbox"},[_c('div',{staticClass:"emoji-box-cont"},_vm._l((_vm.emoji_icon),function(item,index){return _c('div',{key:index,staticClass:"emoji-box",on:{"click":function($event){return _vm.pickEmoji(index)}}},[_vm._v(" "+_vm._s(item)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }